import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { DialogService } from "src/core/services/ui/dialog.service";
import { ControllerProps } from 'src/router';
import { ObjectUtils } from 'src/core/utils/object';
import { ConfigurationService } from 'src/core/services/configuration.service';
import { EmailDocumentService } from 'src/app/general/email-document-template/email-document.service';
import { EmailTemplatePreviewView } from "./email-template-preview.view";

interface EmailTemplatePreviewControllerParams {
	baseTemplateId: number;
	targetId: number;
	onTemplateSelected: (templateId: number) => void;
	setBusy(isBusy: boolean);
	usages: DocumentGenerationUsage;
	templates: IEmailDocumentTemplateSummary[];
}

export class EmailTemplatePreviewController extends React.Component<EmailTemplatePreviewControllerParams, any> {


	constructor(props) {
		super(props);
	}
	

	render() {

		return (
			<EmailTemplatePreviewView
				items={this.props.templates}
				onTemplateSelected={this.props.onTemplateSelected}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/email-document-template/parts/email-template-preview.controller.tsx